// FrameWorkのプラグイン
import axios from "@/plugins/axios";

// とく放題で追加プラグイン
import repository from "./repository";
import moment from "@/plugins/moment";

export default [axios, repository, moment];
